import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { C } from '../../lib/tokens.js';

export function Breadcrumb({ items }) {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6, padding: '8px 24px',
      background: C.platinum, borderBottom: `1px solid ${C.mercury}`,
      fontSize: 12, color: C.iron, overflowX: 'auto', whiteSpace: 'nowrap',
    }}>
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        const label = typeof it === 'object' ? it.label : it;
        const path = typeof it === 'object' ? it.path : null;
        const state = typeof it === 'object' ? it.state : null;
        const interactive = !isLast && !!path;

        return (
          <Fragment key={i}>
            {i > 0 ? (
              <span className="material-icons" style={{ fontSize: 14, color: C.silver }}>
                chevron_right
              </span>
            ) : null}
            <span
              onClick={() => interactive && navigate(path, state ? { state } : undefined)}
              style={{
                color: isLast ? C.deepsea : C.iron,
                fontWeight: isLast ? 500 : 400,
                cursor: interactive ? 'pointer' : 'default',
                transition: 'color 0.15s ease',
              }}
              onMouseEnter={(e) => {
                if (interactive) e.currentTarget.style.color = C.deepsea;
              }}
              onMouseLeave={(e) => {
                if (interactive) e.currentTarget.style.color = C.iron;
              }}
            >
              {label}
            </span>
          </Fragment>
        );
      })}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions, meta }) {
  return (
    <div style={{
      padding: '20px 24px 16px', background: C.tin, borderBottom: `1px solid ${C.mercury}`,
      display: 'flex', alignItems: 'flex-start', gap: 24,
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <h1 style={{ margin: 0, fontFamily: 'Roboto', fontWeight: 300, fontSize: 26, color: C.deepsea, letterSpacing: '-0.01em', lineHeight: 1.2 }}>{title}</h1>
        {subtitle ? <div style={{ fontSize: 13, color: C.iron, marginTop: 4 }}>{subtitle}</div> : null}
        {meta ? <div style={{ marginTop: 10, display: 'flex', gap: 14, flexWrap: 'wrap' }}>{meta}</div> : null}
      </div>
      {actions ? <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>{actions}</div> : null}
    </div>
  );
}